import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import Loader from './../../components/Loader/Loader'
import Notes from '../../components/FeedingGuidelines/Disclaimer/Disclaimer';
import fetchFeedingGuidelinesDisclaimerAction from './../../store/actions/fetch/fetchFeedingGuidelinesDisclaimerAction';
import * as actionTypes from './../../store/actions/feedingGuidelinesDisclaimerAction';

import * as pdfOutputAction from './../../store/actions/pdfOutputAction';
import domtoimage from 'dom-to-image';
import OnImagesLoaded from 'react-on-images-loaded';

class FeedingGuidelinesDisclaimer extends Component {

  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  doScreenShot() {
    const {screenshots}  = this.props;
    const el = document.getElementById('fc-screenshot-feeding-guidelines-disclaimer');
    const {setScreenShot, onScreenshotError} = this.props;
    if (el){
      domtoimage.toPng(el)
        .then(function (dataUrl) {
          if (screenshots && screenshots['fc-screenshot-feeding-guidelines-disclaimer'] !== dataUrl){
            setScreenShot(dataUrl);
          }
        })
        .catch(function () {
          onScreenshotError();
        });
    } else {
      onScreenshotError();
    }
  }

  render() {
    const {data, pending, ready, error} = this.props;

    if(pending || !ready) return (
      <Loader/>
    );

    return (
      <OnImagesLoaded
        onLoaded={this.doScreenShot.bind(this)}
        onTimeout={this.doScreenShot.bind(this)}
        timeout={7000}>

        <Notes data={data}/>

      </OnImagesLoaded>
    )
  }
}

const mapStateToProps = state => {
  return {
    data: state.feedingGuidelinesDisclaimerReducer.data,
    pending: state.feedingGuidelinesDisclaimerReducer.pending,
    ready: state.feedingGuidelinesDisclaimerReducer.ready,
    error: state.feedingGuidelinesDisclaimerReducer.error,
    screenshots: state.pdfOutputReducer.images,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchFeedingGuidelinesDisclaimerAction
      },
      dispatch,
    ),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
    setScreenShot: (data) => dispatch({
      type: pdfOutputAction.ADD,
      key: 'fc-screenshot-feeding-guidelines-disclaimer',
      data: data,
    }),
    onScreenshotError: () => dispatch({
      type: pdfOutputAction.SCREENSHOT_ERROR,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedingGuidelinesDisclaimer);
